import { Route, Routes } from "react-router-dom";

import { Andamio } from "./features/dev/Andamio";
import { EditorPage } from "./features/editor/EditorPage";
import { SubidaPage } from "./features/upload/SubidaPage";

/**
 * Las rutas del editor nuevo.
 *
 * Tres estados, no siete pasos:
 *   /                  subir la HV (o empezar en blanco)
 *   /editor/:cvId      el documento con sus cambios, editable por clic
 *   /revisar/:cvId     alias del anterior, por enlaces antiguos
 */
export const Rutas = () => (
  <Routes>
    <Route path="/" element={<SubidaPage />} />
    {/* La revisión no es una pantalla aparte: vive como pestaña del editor,
        para poder leer el documento mientras se decide sobre cada cambio.
        Se conserva la ruta porque los correos y enlaces viejos apuntan aquí. */}
    <Route path="/revisar/:cvId" element={<EditorPage />} />
    <Route path="/editor/:cvId" element={<EditorPage />} />
    <Route path="*" element={<Andamio ruta="404" fase="—" />} />
  </Routes>
);
